import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSource } from 'shared/selectors';
import { selectJsonQuery } from 'shared/selectors/results';

import { useCatalogs } from './hooks';
import { trackBannersShow } from './tracking';
import { getOffers } from '../../../selectors/offers';
import { TSuburbanCatalog } from '../../../types/suburbanCatalog';
import { SuburbanCatalogs } from '../../components/SuburbanCatalogs';

interface ISuburbanCatalogsContainerProps {
  catalogsTypes: TSuburbanCatalog[];
  fullWidth?: boolean;
}

export const SuburbanCatalogsContainer: React.FC<ISuburbanCatalogsContainerProps> = ({ catalogsTypes, fullWidth }) => {
  const catalogs = useCatalogs(catalogsTypes);
  const offers = useSelector(getOffers);
  const jsonQuery = useSelector(selectJsonQuery);
  const source = useSelector(selectSource);

  const handleShow = React.useCallback(() => {
    trackBannersShow(jsonQuery, source);
  }, [jsonQuery, source]);

  if (!catalogs.length || !offers.length) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.5} triggerOnce>
      <SuburbanCatalogs catalogs={catalogs} fullWidth={fullWidth} />
    </ActionAfterViewObserver>
  );
};
